export default __webpack_public_path__ + "static/media/oil_derrick.0a020d71.svg";